import { useState } from 'react';

import { TrackAssessmentResult } from '@backrs_ui/common-ui';

import { useAssessMyTrackMutation } from '@backrs_ui/grow-ui/src/redux/trackAssessment/trackAssessment.api';

export const useTrackAssessment = () => {
  const [assessMyTrack, { isLoading }] = useAssessMyTrackMutation();
  const [trackAssessmentResult, setTrackAssessmentResult] = useState<TrackAssessmentResult | null>(
    null,
  );

  const handleAssess = async () => {
    try {
      const result = await assessMyTrack(undefined);

      if (!result.data) {
        return null;
      }

      const assessmentResult = result.data;

      setTrackAssessmentResult(assessmentResult);

      return assessmentResult;
    } catch (err) {
      console.error(err);

      return null;
    }
  };

  return {
    handleAssess,
    isAssessing: isLoading,
    trackAssessmentResult,
  };
};
